import { Typography } from '@eventbrite/marmalade';
import classNames from 'classnames';
import React from 'react';
import styles from './KPIContent.module.scss';

export interface KPIContentProps {
  kpiCaption?: string;
  kpiMetric?: string;
  kpiLabel?: string;
  className?: string;
}

export const KPIContent: React.FC<KPIContentProps> = ({
  kpiCaption,
  kpiMetric,
  kpiLabel,
  className,
}) => {
  const styleClassNames = classNames(styles.kpi_content, className);

  return (
    <div className={styleClassNames}>
      {kpiCaption && <Typography className={styles.kpi_caption}>{kpiCaption}</Typography>}
      {kpiMetric && <Typography className={styles.kpi_metric}>{kpiMetric}</Typography>}
      {kpiLabel && <Typography className={styles.kpi_label}>{kpiLabel}</Typography>}
    </div>
  );
};
